import { supabase } from '@/lib/supabaseClient';
import { TABLE_NAMES } from '@/lib/constants';

export interface Edificio {
  id_edificio?: string;
  nombre_edificio: string;
  direccion?: string;
  numero_unidades?: number;
  administrador_responsable_id?: string;
  fecha_creacion?: string;
}

export const buildingService = {
  async getBuildings() {
    const { data, error } = await supabase
      .from(TABLE_NAMES.EDIFICIO)
      .select('*');
    if (error) throw error;
    return data;
  },

  async createBuilding(building: Edificio) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.EDIFICIO)
      .insert([building])
      .select();
    if (error) throw error;
    return data[0];
  },

  async updateBuilding(id: string, updates: Partial<Edificio>) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.EDIFICIO)
      .update(updates)
      .eq('id_edificio', id)
      .select();
    if (error) throw error;
    return data[0];
  },

  async deleteBuilding(id: string) {
    const { error } = await supabase
      .from(TABLE_NAMES.EDIFICIO)
      .delete()
      .eq('id_edificio', id);
    if (error) throw error;
    return true;
  },
};